import BrowserWidthBucket from 'owa-layout/lib/store/schema/BrowserWidthBucket';

/**
 * Returns a flag indicating whether to show folder pane as an overlay or not
 */
export default function shouldShowFolderPaneAsOverlay(browserWidthBucket: BrowserWidthBucket) {
    return browserWidthBucket <= BrowserWidthBucket.From1000_To1079;
}
